import { memo, forwardRef, Ref } from 'react';

type IFrameProps = {
    title?: string;
};

function IFrame({ title }: IFrameProps, ref: Ref<HTMLIFrameElement>) {
    return <iframe title={title} src="about:blank" className="w-full h-full" ref={ref} data-hj-allow-iframe="" />;
}

export default memo(forwardRef(IFrame));
